import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

import Fisher from "../assets/Fisher.png";
import Login from "../assets/login.png";
import Port1 from "../assets/port.png";
import Port2 from "../assets/port-2.png";
import Sl from "../assets/Sl.png";
import Stream from '../assets/Figma-stream.png'
import Game from '../assets/game-app.png';

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-green">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10 text-xl">
          Some of my projects so far, I am updating both github and this portfolio regularly. So please check in om me!
        </p>
      </motion.div>

      {/* PROJECTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3 "
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-pink
              max-w-[400px] max-h-[500px] text-2xl font-playfair font-semibold"
          >
            BEAUTIFUL USER INTERFACES
          </div>
          <img src={Fisher} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]"/>
          <img src={Port1} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]" />

          {/* ROW 2 */}
          <img src={Login} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]" />
          <img src={Port2} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]" />
          <img src={Sl} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]" />

          {/* ROW 3 */}
          <img src={Stream} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]"/>
          <img src={Game} alt="schoolproj" className="flex justify-center text-center items-center
              max-w-[400px] max-h-[500px]" />
          <div
            className="flex justify-center text-center items-center p-10 bg-yellow
              max-w-[400px] max-h-[500px] text-2xl font-playfair font-semibold"
          >
            FOCUS ON USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;